import { render, staticRenderFns } from "./GoodsSelect.vue?vue&type=template&id=5f90be3b&scoped=true"
import script from "./GoodsSelect.vue?vue&type=script&lang=js"
export * from "./GoodsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f90be3b",
  null
  
)

export default component.exports